module.exports = __webpack_public_path__ + "img/Advanced Search - Gray - Selected.17a47fd0.png";